import React, { useState } from "react";
import {
	Grid,
	Box,
	Button,
	TextField,
	FormGroup,
	FormControlLabel,
	Checkbox,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import logo from "../tarteeb.png";
import logo2 from "../logo1.png";
import "../App.css";
import skipcash from "../skipcash.png";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
const callingCodes = ["+974", "+971", "+966", "+973", "+968", "+965"];

export default function Exhibitor() {
	const history = useHistory();

	//State variables
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [businessName, setBusinessName] = useState("");
	const [email, setEmail] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [countryCode, setCountryCode] = useState(callingCodes[0]);

	//Err variable
	const [firstNameErr, setFirstNameErr] = useState(false);
	const [lastNameErr, setLastNameErr] = useState(false);
	const [businessNameErr, setBusinessNameErr] = useState(false);
	const [emailErr, setEmailErr] = useState(false);
	const [phoneNumberErr, setPhoneNumberErr] = useState(false);

	const [checked, setChecked] = useState(false);

	const sendDetails = () => {
		if (firstName.length === 0) {
			setFirstNameErr(true);
			return;
		}

		if (lastName.length === 0) {
			setLastNameErr(true);
			return;
		}

		if (businessName.length === 0) {
			setBusinessNameErr(true);
			return;
		}

		if (email.length === 0) {
			setEmailErr(true);
			return;
		}

		if (phoneNumber.length === 0) {
			setPhoneNumberErr(true);
			return;
		}

		// const reg = new RegExp('^\d+$')
		// if(!reg.test(phoneNumber)) {
		// 	setPhoneNumberErr(true);
		// 	return;
		// }

		history.push({
			pathname: "/reserve",
			state: {
				firstName,
				lastName,
				email,
				businessName,
				phoneNumber: `${countryCode}${phoneNumber}`,
				termsAgreed: checked,
			},
		});
	};

	return (
		<Box
			sx={{
				minHeight: "100vh",
				width: "100%",
				backgroundColor: "#F4F4F5",
			}}
		>
			<Grid container direction="column" alignItems="center">
				<Grid
					container
					direction="column"
					alignItems="center"
					style={{ paddingBottom: "2%" }}
				>
					<Grid
						container
						direction="row"
						style={{ backgroundColor: "white", paddingBottom: "2%" }}
					>
						<Grid
							item
							xs={6}
							style={{
								display: "flex",
								alignSelf: "center",
								justifyContent: "flex-end",
								paddingRight: "0.5%",
							}}
						>
							<img
								alt="tarteeb-logo"
								src={logo}
								style={{ height: 150, width: 200 }}
							/>
						</Grid>
						<Grid
							item
							xs={6}
							style={{
								display: "flex",
								alignSelf: "center",
								justifyContent: "flex-start",
								paddingRight: "0.5%",
							}}
						>
							<img
								alt="rwaiha-logo"
								src={logo2}
								style={{ height: 120, width: 160 }}
							/>
						</Grid>
					</Grid>
				</Grid>

				<Grid
					container
					style={{
						backgroundColor: "white",
						width: "60%",
						margin: "2%",
						borderRadius: 15,
						padding: "2%",
					}}
					rowSpacing={2}
					// columnSpacing={{ xs: 1, sm: 2, md: 3 }}
				>
					<Grid item xs={12}>
						<Grid container direction="row">
							<Grid item xs={6}>
								<h2 style={{ fontFamily: "Poppins", color: "#a67a31" }}>
									Exhibitor Details
								</h2>
							</Grid>
							<Grid
								item
								xs={6}
								style={{ display: "flex", justifyContent: "flex-end" }}
							>
								<h2
									style={{
										fontFamily: "Poppins",
										color: "#a67a31",
										marginRight: "7%",
									}}
								>
									معلومات العارض
								</h2>
							</Grid>
						</Grid>
					</Grid>

					{/* First Name field */}
					<Grid item xs={12}>
						<Grid container direction="row">
							<Grid item xs={6}>
								<label style={{ fontFamily: "Poppins", color: "#a67a31" }}>
									First Name
								</label>
							</Grid>
							<Grid
								item
								xs={6}
								style={{ display: "flex", justifyContent: "flex-end" }}
							>
								<label style={{ fontFamily: "Poppins", color: "#a67a31" }}>
									الإسم الاول
								</label>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12}>
						<TextField
							error={firstNameErr}
							required
							id="first-name"
							placeholder="First Name"
							variant="outlined"
							style={{ width: "100%" }}
							onChange={(e) => {
								setFirstNameErr(false);
								setFirstName(e.target.value);
							}}
						/>
					</Grid>
					{firstNameErr ? (
						<Grid item xs={12}>
							<span style={{ color: "red" }}>* First Name cannot be Empty</span>
						</Grid>
					) : null}

					{/* Last Name field */}
					<Grid item xs={12}>
						<Grid container direction="row">
							<Grid item xs={6}>
								<label style={{ fontFamily: "Poppins", color: "#a67a31" }}>
									Last Name
								</label>
							</Grid>
							<Grid
								item
								xs={6}
								style={{ display: "flex", justifyContent: "flex-end" }}
							>
								<label style={{ fontFamily: "Poppins", color: "#a67a31" }}>
									إسم العائلة
								</label>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12}>
						<TextField
							error={lastNameErr}
							required
							id="last-name"
							placeholder="Last Name"
							variant="outlined"
							style={{ width: "100%" }}
							onChange={(e) => {
								setLastNameErr(false);
								setLastName(e.target.value);
							}}
						/>
					</Grid>
					{lastNameErr ? (
						<Grid item xs={12}>
							<span style={{ color: "red" }}>* Last Name cannot be Empty</span>
						</Grid>
					) : null}

					{/* Business Name field */}
					<Grid item xs={12}>
						<Grid container direction="row">
							<Grid item xs={6}>
								<label style={{ fontFamily: "Poppins", color: "#a67a31" }}>
									Business Name
								</label>
							</Grid>
							<Grid
								item
								xs={6}
								style={{ display: "flex", justifyContent: "flex-end" }}
							>
								<label style={{ fontFamily: "Poppins", color: "#a67a31" }}>
									إسم الشركة
								</label>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12}>
						<TextField
							error={businessNameErr}
							required
							id="business-name"
							placeholder="Business Name"
							variant="outlined"
							style={{
								width: "100%",
								fontFamily: "Poppins",
								borderColor: "#a67a31",
							}}
							onChange={(e) => {
								setBusinessNameErr(false);
								setBusinessName(e.target.value);
							}}
						/>
					</Grid>
					{businessNameErr ? (
						<Grid item xs={12}>
							<span style={{ color: "red" }}>
								* Business Name cannot be Empty
							</span>
						</Grid>
					) : null}

					{/* Email field */}
					<Grid item xs={12}>
						<Grid container direction="row">
							<Grid item xs={6}>
								<label style={{ fontFamily: "Poppins", color: "#a67a31" }}>
									Email
								</label>
							</Grid>
							<Grid
								item
								xs={6}
								style={{ display: "flex", justifyContent: "flex-end" }}
							>
								<label style={{ fontFamily: "Poppins", color: "#a67a31" }}>
									البريد الإلكتروني
								</label>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12}>
						<TextField
							type="email"
							error={emailErr}
							required
							id="email"
							placeholder="Email"
							variant="outlined"
							style={{ width: "100%" }}
							onChange={(e) => {
								setEmailErr(false);
								setEmail(e.target.value);
							}}
						/>
					</Grid>
					{emailErr ? (
						<Grid item xs={12}>
							<span style={{ color: "red" }}>* Email cannot be Empty</span>
						</Grid>
					) : null}

					{/* Phone Number field */}
					<Grid item xs={12}>
						<Grid container direction="row">
							<Grid item xs={6}>
								<label style={{ fontFamily: "Poppins", color: "#a67a31" }}>
									Phone Number
								</label>
							</Grid>
							<Grid
								item
								xs={6}
								style={{ display: "flex", justifyContent: "flex-end" }}
							>
								<label style={{ fontFamily: "Poppins", color: "#a67a31" }}>
									رقم الهاتف
								</label>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12}>
						<Grid container>
							<Grid item xs={2}>
								{/* <TextField
									error={phoneNumberErr}
									required
									id="country-code"
									value={countryCode}
									// label="Code"
									variant="outlined"
									style={{ width: "85%" }}
									onChange={(e) => {
										setCountryCode(e.target.value);
									}}
								/> */}
								<FormControl fullWidth>
									{/* <InputLabel id="demo-simple-select-la/bel">Code</InputLabel> */}
									<Select
										required
										error={phoneNumberErr}
										labelId="demo-simple-select-label"
										id="country-code"
										value={countryCode}
										style={{ width: "85%" }}
										// placeholder="Code"
										onChange={(e) => setCountryCode(e.target.value)}
									>
										{
											callingCodes.map(item => <MenuItem value={item}>{item}</MenuItem>)
										}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={10}>
								<TextField
									type="number"
									error={phoneNumberErr}
									required
									id="phone-number"
									placeholder="Phone Number"
									variant="outlined"
									style={{ width: "100%" }}
									onChange={(e) => {
										setPhoneNumberErr(false);
										setPhoneNumber(e.target.value);
									}}
								/>
							</Grid>
						</Grid>
					</Grid>
					{phoneNumberErr ? (
						<Grid item xs={12}>
							<span style={{ color: "red" }}>
								* Phone Number cannot be Empty
							</span>
						</Grid>
					) : null}

					{/* Checkbox for agreement */}
					<Grid item xs={12}>
						<FormGroup style={{ width: "80%" }}>
							<FormControlLabel
								control={
									<Checkbox
										onChange={(e) => setChecked(e.target.checked)}
										style={{ borderColor: "#a67a31", color: "#a67a31" }}
									/>
								}
								label={
									<p style={{ fontFamily: "Poppins", color: "#a67a31" }}>
										By checking this box, you agree to the{" "}
										<a
											target="_blank"
											rel="noreferrer"
											href="https://firebasestorage.googleapis.com/v0/b/tarteeb-c3b98.appspot.com/o/T%26C.pdf?alt=media&token=a3f3e779-885f-4843-ba34-5d60aae5f969"
										>
											Terms and Conditions
										</a>
									</p>
								}
							/>
							{/* <FormControlLabel
								label={
									<p style={{ fontFamily: "Poppins", color: "#a67a31" }}>
										j
									</p>
								}
							/> */}
						</FormGroup>
					</Grid>

					<Grid item xs={12}>
						<Button
							disabled={!checked}
							style={
								checked
									? {
											width: "80%",
											fontFamily: "Poppins",
											color: "white",
											borderColor: "#a67a31",
											backgroundColor: "#a67a31",
									  }
									: {
											width: "80%",
											fontFamily: "Poppins",
											color: "white",
											borderColor: "#F4f4f5",
											backgroundColor: "#A4A4A5",
									  }
							}
							variant="outlined"
							onClick={() => sendDetails()}
						>
							Agree | موافق
						</Button>
					</Grid>
				</Grid>
				<Grid container justifyContent="center">
					<img alt="skipcash" src={skipcash} />
				</Grid>
			</Grid>
		</Box>
	);
}
